import { Text, TextDescription, TextTitle } from "../components/Texts";
import { useDispatch, useSelector } from "react-redux";

import Column from "../components/Column";
import DatePicker from "../components/DatePicker";
import React from "react";
import Row from "../components/Row";
import TrendingGraph1 from "components/performance/TrendingGraph1";
import TrendingGraph2 from "components/performance/TrendingGraph2";
import _find from "lodash/find";
import _forEach from "lodash/forEach";
import _get from "lodash/get";
import _orderBy from "lodash/orderBy";
import _split from "lodash/split";
import _values from "lodash/values";
import colors from "../styles/colors";
import { compose } from "redux";
import mainSelectors from "../modules/main/selectors";
import moment from "moment";

import performanceAction from "../modules/performance/actions";
import performanceSelectors from "../modules/performance/selectors";

import styled from "styled-components";
import { useEffect } from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import withUserPerm from "services/withUserPerm";

import Loading from "components/Loading";
import { useLocation } from "react-router-dom";
import TopBar from "../components/TopBar";
import useWindowSize from "../layout/useWindowSize";
import pageTitleList from "../modules/utils/pageTitleList";
import { useHistory } from "react-router-dom";

const Performance = () => {
  //eslint-disable-next-line no-unused-vars
  const [t] = useTranslation();
  const dispatch = useDispatch();
  let selectedView = { title: "R-CRM", value: "R-CRM" };

  const currentAd = useSelector((state) => mainSelectors.currentAd(state));
  const gGraphList = useSelector((state) => performanceSelectors.ggraphList(state));
  const [selectedViewValue, setSelectedViewValue] = useState();
  const [yesterdayAsDefault, setYesterdayAsDefault] = useState(false);
  const [loading, setLoading] = useState(true);
  const [conversionDataList, setConversionDataList] = useState({
    rwidget: {},
    rcrm: {},
    googlesheets: {},
  });
  const [dataFirstLoaded, setDataFirstLoaded] = useState(false);
  const location = useLocation();
  const history = useHistory();
  const titleAndSubTitle = pageTitleList.getPageTitleList(t);
  const titleName = titleAndSubTitle[history.location.pathname]
    ? titleAndSubTitle[history.location.pathname].title
    : title;
  const subTitleName = titleAndSubTitle[history.location.pathname]
    ? titleAndSubTitle[history.location.pathname].subTitle || ""
    : "";
  const RcrmAppAvailableResult = useSelector((state) => mainSelectors.checkAppAvailableResult(state));

  useEffect(() => {
    setLoading(true);
    const rmpToken = sessionStorage.getItem("rmp_token");

    if (selectedViewValue && dataFirstLoaded === true) {
      const getPerformance = async () => {
        try {
          setLoading(true);
          await dispatch(
            performanceAction.GetGGraph({
              ads_account_id: currentAd.ads_account_id,
              date_preset: selectedViewValue.key,
            }),
          );
          setLoading(false);
        } catch (error) {
          setLoading(false);
        }
      };
      getPerformance();
    } else if (dataFirstLoaded === false && selectedViewValue && selectedViewValue.key === "today") {
      setDataFirstLoaded(true);
    }
  }, [selectedViewValue, currentAd.ads_account_id, dispatch]);

  useEffect(() => {
    if (gGraphList) {
      const graphData = gGraphList || {};

      setConversionDataList({
        rwidget: graphData.rwidget,
        rcrm: graphData.rcrm,
        googlesheets: graphData.googlesheets,
      });

      if (!yesterdayAsDefault && selectedViewValue && selectedViewValue.key === "today") {
        setYesterdayAsDefault(true);
        setLoading(false);
      }
    }
  }, [gGraphList, selectedViewValue]);

  return (
    <div>
      <StyledContainerTop useWindowSize={useWindowSize()}>
        <StyledContainerTopBar useWindowSize={useWindowSize()}>
          <TopBar title={titleName} subTitle={subTitleName} />
        </StyledContainerTopBar>
        <DatePicker
          key={moment.locale() + " " + yesterdayAsDefault}
          onSelected={setSelectedViewValue}
          defaultIndex={yesterdayAsDefault ? 1 : 0}
        />
      </StyledContainerTop>
      {loading === true ? (
        <Loading />
      ) : (location.pathname == "/rmp-conversions/r-widget" &&
          conversionDataList.rwidget &&
          conversionDataList.rwidget.all.data.length > 0) ||
        (location.pathname == "/rmp-conversions/r-crm" &&
          conversionDataList.rcrm &&
          conversionDataList.rcrm.all.data.length > 0) ||
        (location.pathname == "/rmp-conversions/google-sheets" &&
          conversionDataList.googlesheets &&
          conversionDataList.googlesheets.all.data.length > 0) ? (
        <>
          <Row>
            <Column>
              <RenderContent dataList={conversionDataList} selectedViewValue={selectedViewValue} />
            </Column>
          </Row>
        </>
      ) : (
        <EmptyContent />
      )}
    </div>
  );
};

export default compose(withUserPerm())(Performance);

const EmptyContent = () => {
  const [t] = useTranslation();
  return (
    <StyledEmptyContainer>
      <p>{t("__no_data")}</p>
    </StyledEmptyContainer>
  );
};

const RenderContent = ({ dataList, selectedViewValue }) => {
  const location = useLocation();
  switch (location.pathname) {
    case "/rmp-conversions/r-widget":
      return <RWidgetContent dataList={dataList.rwidget} selectedViewValue={selectedViewValue} />;
    case "/rmp-conversions/r-crm":
      return <RCRMContent dataList={dataList.rcrm} selectedViewValue={selectedViewValue} />;
    case "/rmp-conversions/google-sheets":
      return <GoogleSheetsContent dataList={dataList.googlesheets} selectedViewValue={selectedViewValue} />;
    default:
      return <RWidgetContent dataList={dataList.rwidget} selectedViewValue={selectedViewValue} />;
  }
};

const RWidgetContent = ({ dataList, selectedViewValue }) => {
  const selectedViewRWidget = { title: "R-Widget", value: "R-Widget" };
  return <TrendingGraph1 dataList={dataList} view={selectedViewRWidget} selectedViewValue={selectedViewValue} />;
};

const GoogleSheetsContent = ({ dataList, selectedViewValue }) => {
  const selectedViewRAds = { title: "Google Sheets", value: "Google Sheets" };
  return <TrendingGraph1 dataList={dataList} view={selectedViewRAds} selectedViewValue={selectedViewValue} />;
};

const RCRMContent = ({ dataList, selectedViewValue }) => {
  const selectedView = { title: "R-CRM", value: "R-CRM" };
  return <TrendingGraph2 dataList={dataList} view={selectedView} selectedViewValue={selectedViewValue} />;
};

const StyledEmptyContainer = styled.div`
  min-height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${colors.descriptionText};
`;

const StyledContainerTop = styled.div.attrs((props) => ({
  display: props.useWindowSize.width < 835 ? "block" : "flex",
}))`
  display: ${(props) => props.display};
  justify-content: space-between;
  margin-bottom: 24px;
  display: ;
`;

const StyledContainerTopBar = styled.div.attrs((props) => ({
  display: props.useWindowSize.width < 835 ? "none" : "block",
}))`
  display: ${(props) => props.display};
`;
